import { render, staticRenderFns } from "./ConfirmTechTagModal.vue?vue&type=template&id=97baf384&scoped=true"
import script from "./ConfirmTechTagModal.vue?vue&type=script&lang=js"
export * from "./ConfirmTechTagModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTechTagModal.vue?vue&type=style&index=0&id=97baf384&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97baf384",
  null
  
)

export default component.exports